import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M9.333 9.333H6.667a.667.667 0 0 0 0 1.334h2.666a.667.667 0 0 0 0-1.334m4-3.373a1 1 0 0 0-.04-.18v-.06a.7.7 0 0 0-.126-.187l-4-4a.7.7 0 0 0-.187-.126h-.06a.6.6 0 0 0-.22-.074H4.667a2 2 0 0 0-2 2v9.334a2 2 0 0 0 2 2h6.666a2 2 0 0 0 2-2V5.96m-4-2.353 1.727 1.726H10a.667.667 0 0 1-.667-.666zM12 12.667a.667.667 0 0 1-.667.666H4.667A.667.667 0 0 1 4 12.667V3.333a.667.667 0 0 1 .667-.666H8v2a2 2 0 0 0 2 2h2z"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })